import React = require("react");
import Modul from './Modul';
import l10n from "diy/util/l10n";
import AppRegistry from "diy/AppRegistry";
import {
    load, getEditViewComponent, getAdvancedViewComponent,
    ModuleSectionData, stopEditing, clickOutside,
    closeManageGroupsIfActive, supportsAddGroup,
    ModuleSectionState, getGroupsViewComponent, toggleManageGroups,
    isToggleableElement
} from './section/index';
import {AppState} from 'diy/redux/app/state';

import {SectionKpiEventsTypes, emitKpiEvent} from "./section/tracking";

import {watchSize} from "diy/util/watchSize";
import {refreshWeb, destroyWeb} from "diy/module/section/web/index";

function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

function getState() {
    return (AppRegistry.getStoreProvider().getStore().getState() as AppState).moduleSection as ModuleSectionState;
}

export default class ModulSection extends Modul {
    extraMarginToSetTop = 42;
    hasActionBar = true;
    justUpdateWithoutRefresh = false;
    changeEventTriggered = false;
    helpArticleId = "addsections";
    data: ModuleSectionData;
    private parallaxStopListening: () => void;

    save() {
        //save functionality is disabled
        //we do all changes/saving through redux-react component
        this.close(true, false, true, false);
    }
    open() {
        getStore().dispatch(load({ moduleId: this.moduleId, data: this.data }));
        emitKpiEvent(SectionKpiEventsTypes.Open);
        super.open.apply(this, arguments);
        this.parallaxStartListening();
    }
    hasToggleableElement(alias: string) {
        return isToggleableElement(alias, getState());
    }
    getActionBarTabs() {
        let tabs = super.getActionBarTabs();
        if (supportsAddGroup(getState())) {
            tabs.push({
                label: l10n('section.actionBar.tabs.groups.label'),
                content: this.getGroupsViewComponent()
            });
        }
        tabs.push({
            label: l10n('section.actionBar.tabs.advanced.label'),
            content: this.getAdvancedViewComponent()
        });
        return tabs;
    }
    onActionBarTabChange(v: number) {
        switch (v) {
            case 0:
                emitKpiEvent(SectionKpiEventsTypes.MainTab);
                getStore().dispatch(closeManageGroupsIfActive());
                break;
            case 1:
                if (supportsAddGroup(getState())) {
                    emitKpiEvent(SectionKpiEventsTypes.GroupsTab);
                    getStore().dispatch(toggleManageGroups(true));
                } else {
                    emitKpiEvent(SectionKpiEventsTypes.DesignTab);
                    getStore().dispatch(closeManageGroupsIfActive());
                }
                break;
            case 2:
                emitKpiEvent(SectionKpiEventsTypes.DesignTab);
                getStore().dispatch(closeManageGroupsIfActive());
                break;
            default:
                // nothing
        }
    }

    close(userClose: boolean, cancelEdit: boolean, isSaving: boolean, isUserAction: boolean) {
        super.close(userClose, cancelEdit, isSaving, isUserAction);
        getStore().dispatch(stopEditing());
        if (this.parallaxStopListening) {
            this.parallaxStopListening();
        }
    }

    remove() {
        if (this.data.background.parallax) {
            destroyWeb(this.moduleId);
            if (this.parallaxStopListening) {
                this.parallaxStopListening();
            }
        }
        super.remove();
    }

    updateModul() {
        super.updateModul.apply(this, arguments);

        //HACK: We need the new module instance because this one is getting destroyed
        //HACK: we use setTimeout because the new module element is not yet appended
        setTimeout(() => {
            (Modul.getInstance(this.moduleId) as this).parallaxStartListening();
        }, 100);
    }

    getEditViewComponent() {
        const ConnectedEditView = getEditViewComponent(getStore());
        return React.createElement(ConnectedEditView);
    }

    onClickOutside() {
        getStore().dispatch(clickOutside());
    }

    emitCloseKpi() {
        emitKpiEvent(SectionKpiEventsTypes.Close, 'button');
    }

    getData() {
        return this.data;
    }

    private parallaxStartListening() {
        if (!this.data.background.parallax) {
            return;
        }
        this.parallaxStopListening = watchSize(this.moduleElement, () => {
            refreshWeb(this.moduleId);
        });
    }

    private getAdvancedViewComponent() {
        const ConnectedAdvancedView = getAdvancedViewComponent(getStore());
        return React.createElement(ConnectedAdvancedView);
    }

    private getGroupsViewComponent() {
        const ConnectedGroupsView = getGroupsViewComponent(getStore());
        return React.createElement(ConnectedGroupsView);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulSection.ts
 **/